module.exports = __webpack_public_path__ + "img/database.05fe2a9f.svg";